<template>
  <button
      v-ripple
      :disabled="disabled"
      :class="{outlined, big}"
      @click="$emit('click')"
  >
    <slot/>
  </button>
</template>

<script>
export default {
  name: "app-button",
  props: {
    outlined:{
      type: Boolean,
      default: false
    },
    disabled:{
      type: Boolean,
      default: false
    },
    big:{
      type: Boolean,
      default: false
    },
  }
}
</script>

<style lang="scss" scoped>
  button{
    width: 100%;
    height: 40px;
    background: #2CB181;
    border-radius: 4px;
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    text-align: center;
    color: #FFFFFF;
    border: none;
    cursor: pointer;
    padding: 0 20px;

    &.big{
      height: 50px;
    }

    &:disabled{
      user-select: none;
      cursor: default !important;
      background: #B6BCC8;

      &:hover{
        background: #B6BCC8;
      }
    }

    &.outlined{
      background: transparent;
      border: 1px solid #B6BCC8;
      box-sizing: border-box;
      border-radius: 4px;
      font-style: normal;
      font-size: 12px;
      color: #7A818F;

      &:hover{
        color: #2CB181;
        border-color: #2CB181;
        background: transparent;
      }
    }

    &:hover{
      background: #25966E;
    }
  }
</style>
